<header tuiNavigationHeader>
  <a routerLink="/" class="flex shrink-0 items-center gap-2 px-2 no-underline text-heading text-gold" aria-label="warcraft-learner home">
    <svg class="w-6 h-6 shrink-0" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path class="fill-gold" d="M16 4 L27 7 L27 15.5 C27 21.5 22.5 26.5 16 29 C9.5 26.5 5 21.5 5 15.5 L5 7 Z"/>
      <g class="fill-surface">
        <rect x="9.5" y="18" width="3" height="4" rx="1"/>
        <rect x="14.5" y="14" width="3" height="8" rx="1"/>
        <rect x="19.5" y="10" width="3" height="12" rx="1"/>
      </g>
    </svg>
    <span>warcraft-learner</span>
  </a>
  @if (!isMobile()) {
    <h1 class="min-w-0 truncate px-2 text-heading">{{ pageTitle() }}</h1>
  }
  <hr />
  @if (isMobile()) {
    <a tuiIconButton iconStart="github" [href]="githubUrl" target="_blank" rel="noopener noreferrer">View on GitHub</a>
    <a tuiIconButton iconStart="bug_report" [href]="newIssueUrl" target="_blank" rel="noopener noreferrer">Report an issue</a>
  }
</header>

<div class="flex">
  @if (!isMobile()) {
    <aside class="h-[calc(100dvh-3rem)]" [tuiNavigationAside]="expanded()">
      <a tuiAsideItem iconStart="lightbulb" routerLink="/pre">Pre-fight</a>
      <a tuiAsideItem iconStart="analytics" routerLink="/" [routerLinkActiveOptions]="{ exact: true }">Analyze</a>
      <footer>
        <a tuiAsideItem iconStart="github" [href]="githubUrl" target="_blank" rel="noopener noreferrer">View on GitHub</a>
        <a tuiAsideItem iconStart="bug_report" [href]="newIssueUrl" target="_blank" rel="noopener noreferrer">Report an issue</a>
        <button tuiAsideItem type="button" [iconStart]="expanded() ? 'left_panel_close' : 'left_panel_open'" (click)="toggleRail()">{{ expanded() ? 'Collapse menu' : 'Expand menu' }}</button>
      </footer>
    </aside>
  }

  <!-- The bottom padding keeps the last card clear of the fixed tab bar and the phone's home indicator. -->
  <main class="block min-w-0 flex-1 max-md:pb-[calc(3.5rem+env(safe-area-inset-bottom))]">
    <ng-content></ng-content>
  </main>
</div>

@if (isMobile()) {
  <!-- The wrapper is what is fixed: the tab bar's own position: relative is unlayered and beats a layered fixed utility. -->
  <div class="fixed inset-x-0 bottom-0 z-10">
    <nav tuiTabBar class="pb-[env(safe-area-inset-bottom)]">
      <a tuiTabBarItem icon="lightbulb" routerLink="/pre" routerLinkActive>Pre-fight</a>
      <a tuiTabBarItem icon="analytics" routerLink="/" routerLinkActive [routerLinkActiveOptions]="{ exact: true }">Analyze</a>
    </nav>
  </div>
}
